<template>
  <v-row class="d-flex flex-wrap">
    <!-- filter -->
    <v-col cols="12">
      <CustomAnalysisFilter @changechartInfoState="changeChartInfoState" :chartInfoState="chartInfoState" :chartInfo="chartInfo"/>
    </v-col>
    <v-col :class="{ 'd-none': getDateRange.length < 1 }">
      <v-row>
        <CustomBase id="customBase" @goto="scrollToTarget" @addChartInfo="addChart" :chartInfoState="chartInfoState"/>
        <div id="CustomerGroupTrend" style="display:none"></div>
      </v-row>
      <v-row>
        <!-- 單日客群分析 -->
        <v-col cols="12" md="6" id="Customer">
          <Customer id="customer" @goto="scrollToTarget" @addChartInfo="addChart" :chartInfoState="chartInfoState"/>
          <div id="CustomerGroupAnalysis" style="display:none"></div>
        </v-col>

        <!-- 單日活躍客群 -->
        <v-col cols="12" md="6" id="Distributed">
          <Distributed id="distributed" @goto="scrollToTarget" @addChartInfo="addChart" :chartInfoState="chartInfoState"/>
          <div id="newVisitors" style="display:none"></div>
          <div id="activeCustomers" style="display:none"></div>
          <div id="potentialCustomers" style="display:none"></div>
          <div id="returningVisitors" style="display:none"></div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import highcharts from "highcharts";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      chart:[],
      chartInfo: [],
      chartInfoState: false,
    };
  },
  components: {
    CustomAnalysisFilter: () =>
        import("@/components/customanalysis/CustomAnalysisFilter.vue"),

    CustomBase: () => import("@/components/customanalysis/CustomBase.vue"),
    Customer: () => import("@/components/customanalysis/Customer.vue"),
    Distributed: () => import("@/components/customanalysis/Distributed.vue"),
  },
  computed: {

    ...mapGetters("customanalysis", ["getDateRange"]),
  },
  methods: {
    scrollToTarget(value) {
      this.$vuetify.goTo(value);
    },
    addChart(value) {
      this.chartInfo.push(Object.assign(value));
    },
    changeChartInfoState(value){
      this.chartInfoState = value;
      if(value ===false){
        this.chartInfo = [];
      }
    },
  },
};
</script>
